import { OdataOrderbyGenerator } from '../../../interfaces/odata-orderby-generator';

export class DesignatedUnitsTableOrderbyRequest implements OdataOrderbyGenerator {
  public unitName: string | null = null;
  public clientUnitId: string | null = null;
  public designatedUnitType: string | null = null;

  [key: string]: any; // Index signature to allow dynamic property querying

  constructor(orderByString: string | null = null) {
    if (orderByString) {
      this.setOrderByFromString(orderByString);
    }
  }

  // Allows us to populate the req object from a string such as "firstName asc"
  setOrderByFromString(orderByString: string): void {
    // Split the input string into property and order
    const [property, order] = orderByString.split(' ');

    // Check if the property exists in the class
    if (this.hasOwnProperty(property)) {
      // Set the property value
      this[property] = order;
    } else {
      console.error(`Property ${property} does not exist in DesignatedUnitsTableOrderbyRequest.`);
    }
  }

  getOrderByString(): string | null {
    const orderByClauses = [];

    for (const property in this) {
      if (this[property] !== null && typeof this[property] === 'string') {
        // Handle special case for DesignatedUnitType
        if (property === 'designatedUnitType') {
          orderByClauses.push(`DesignatedUnitType/Name ${this[property]}`);
        } else {
          orderByClauses.push(`${property} ${this[property]}`);
        }
      }
    }

    if (orderByClauses.length > 1) {
      return orderByClauses.join(',');
    } else if (orderByClauses.length === 1) {
      return orderByClauses[0];
    } else {
      return null;
    }
  }
}
